import * as React from 'react';
import { FormattedMessage } from 'react-intl';

import { Item } from 'Components/Grid';
import HistoryRowControls from 'Components/HistoryRowControls';
import HistoryRowListing from 'Components/HistoryRowListing';
import HistorySection from 'Components/HistorySection';
import DocumentCreationButton from 'Components/DocumentCreationButton';
import { statementStyle } from '../Components/Statement';

const showProcedureCode = (d: IDocumentWithTypeV2<'dexa'>) => d.procedureCode && d.procedureCode.length > 0;
const showStatement = (d: IDocumentWithTypeV2<'dexa'>) => d.statement && d.statement.length > 0;

const DEXA = ({ documents, startEdit }: IOwnProps): React.JSX.Element => {
  const showProcedureCodeHeader = documents.some(d => showProcedureCode(d));
  const showStatementHeader = documents.some(d => showStatement(d));

  return (
    <HistorySection
      headerText={<FormattedMessage id={'imaging.dexa'} />}
      newButton={
        <DocumentCreationButton
          name="dexa"
          text={'imaging.newdexa'}
          onClick={startEdit({}, 'dexa')}
          width={15}
          height={3}
          fontSize={14}
          alternate={true}
        />
      }
    >
      <HistoryRowListing
        documents={documents}
        headers={
          <>
            {showProcedureCodeHeader && (
              <Item xs={2}>
                <FormattedMessage id="imaging.procedureCode" />
              </Item>
            )}
            {showStatementHeader && (
              <Item xs={3}>
                <FormattedMessage id="imaging.statementText" />
              </Item>
            )}
          </>
        }
        contentFormat={d => (
          <>
            {showProcedureCodeHeader && <Item xs={2}>{showProcedureCode(d) ? d.procedureCode : ''}</Item>}
            {showStatementHeader && (
              <Item xs={3} style={statementStyle}>
                {showStatement(d) ? d.statement : ''}
              </Item>
            )}
          </>
        )}
        makeDate
        makeControls
        historyRowControls={d => <HistoryRowControls document={d} startEdit={startEdit} />}
      />
    </HistorySection>
  );
};

interface IOwnProps {
  documents: IDocumentWithTypeV2<'dexa'>[];
  startEdit: StartEdit;
}

export default DEXA;
